import {OpenAIModel} from '../../openAI/openAI.enums';
import {OpenAIModelConfig} from '../../openAI/openAI.models';
import getLLMModel from './getLLMModel';

function getDefaultLLMModel(): OpenAIModelConfig {
  const defaultModel = getLLMModel(OpenAIModel.Gpt5_1);

  return defaultModel;
}

export default getDefaultLLMModel;
